import ToastPlugin from 'vue-toast-notification';
import { defineNuxtPlugin } from '#app';

import 'vue-toast-notification/dist/theme-sugar.css';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ToastPlugin);
});
